import React, { useState, useEffect } from "react";
import { Toggle, ChoiceGroup } from "@fluentui/react";
import Axios from "axios";

const BuzzerLedFrame = ({ setCurrentFrame, panel }) => {
    const [currentTime, setCurrentTime] = useState("");
    const [buzzer, setBuzzer] = useState(panel?.VT5000_CONFIG?.GeneralParameters?.buzzerDisabled || 0);
    const [blinkLed, setBlinkLed] = useState(panel?.VT5000_CONFIG?.GeneralParameters?.devicePollingLed || 0);
    const [redLed, setRedLed] = useState(panel?.VT5000_CONFIG?.GeneralParameters?.loop1LedBlinkColour || 0);
    const [ledBacklight, setLedBacklight] = useState(panel?.VT5000_CONFIG?.GeneralParameters?.panelLedBacklightColour === 1 ? "Blue" : panel?.VT5000_CONFIG?.GeneralParameters?.panelLedBacklightColour === 2 ? "Green" : panel?.VT5000_CONFIG?.GeneralParameters?.panelLedBacklightColour === 4 ? "White" : "None");

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            let formattedTime = now.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(/,/g, ""); // Remove comma between date and time

            formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
            setCurrentTime(formattedTime);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleSave = () => {
        if (panel?.VT5000_CONFIG?.GeneralParameters) {
            panel.VT5000_CONFIG.GeneralParameters.buzzerDisabled = buzzer ? 1 : 0;
            panel.VT5000_CONFIG.GeneralParameters.devicePollingLed = blinkLed ? 1 : 0;
            panel.VT5000_CONFIG.GeneralParameters.loop1LedBlinkColour = redLed ? 1 : 0;
            if (ledBacklight === "Blue") {
                panel.VT5000_CONFIG.GeneralParameters.panelLedBacklightColour = 1;
            }
            else if (ledBacklight === "Green") {
                panel.VT5000_CONFIG.GeneralParameters.panelLedBacklightColour = 2;
            }
            else if (ledBacklight === "White") {
                panel.VT5000_CONFIG.GeneralParameters.panelLedBacklightColour = 4;
            }
            else {
                panel.VT5000_CONFIG.GeneralParameters.panelLedBacklightColour = 0;
            }

            const userEmail = localStorage.getItem('userEmail');
            Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_generalparameters`, {
                email: userEmail,
                panelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
                originalPanelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
                generalparameters: panel.VT5000_CONFIG.GeneralParameters
            })
                .then((response) => {
                    if (response.data.success) {
                        console.log("Loop settings updated successfully");
                    } else {
                        console.error("Failed to update loop settings");
                    }
                })
                .catch((error) => {
                    console.error("Error updating loop settings:", error);
                });
        }
    };

    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ fontSize: 40, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ textAlign: "left", flex: 1 }}>Buzzer Led</span>
                <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span>
            </div>
            <hr style={{ width: "100%", border: "1px solid black", margin: "5px 0" }} />

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: "80%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Buzzer</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={buzzer}
                            onChange={() => setBuzzer(!buzzer)}
                            styles={{ pill: { background: buzzer ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{buzzer ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Blinking Led</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={blinkLed}
                            onChange={() => setBlinkLed(!blinkLed)}
                            styles={{ pill: { background: blinkLed ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{blinkLed ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Red Led</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={redLed}
                            onChange={() => setRedLed(!redLed)}
                            styles={{ pill: { background: redLed ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{redLed ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "30px" }}>Led Backlight</span>
                    <ChoiceGroup
                        selectedKey={ledBacklight}
                        options={[
                            { key: "Blue", text: "Blue" },
                            { key: "Green", text: "Green" },
                            { key: "White", text: "White" }
                        ]}
                        onChange={(e, option) => setLedBacklight(option.key)}
                        styles={{ root: { display: "flex", flexDirection: "row", alignItems: "center" }, flexContainer: { display: "flex", flexDirection: "row", gap: "15px" } }}
                    />
                </div>
            </div>

            <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 10% 0 0", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("main")}>Logout</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 1px 0 0", background: "none", borderRadius: "5px" }} onClick={handleSave}>Save</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 0px", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("general")}>Back</button>
            </div>
        </div>
    );
};

export default BuzzerLedFrame;
